import * as yup from 'yup';
import { merge } from 'lodash-es';
import { RendererType } from '../data-models/field-definition';

const ledgerFileTypes = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

const extensionMap = {
  csv: 'text/csv',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
};

export function generalLedgerFields(showNewFileField: boolean) {
  return {
    file: yup
      .mixed()
      .required('Please select one or more files')
      .test('is-valid-size', 'Max file size is 500MB per file', (value) => {
        if (!value) {
          return false;
        }
        if (Array.isArray(value)) {
          return value.every((file: File) => file.size <= 500 * 1024 * 1024);
        }
        return (value as File).size <= 500 * 1024 * 1024;
      })
      .test('is-valid-type', 'Invalid file type', (value) => {
        if (!value) {
          return false;
        }
        if (Array.isArray(value)) {
          return value.every((file: File) => ledgerFileTypes.includes(file.type));
        }
        return ledgerFileTypes.includes((value as File).type);
      })
      .default(null)
      .meta({
        renderer: showNewFileField ? RendererType.fileUpload2 : RendererType.fileUpload,
        rendererMeta: {
          acceptTypes: ledgerFileTypes,
          acceptExtensions: Object.keys(extensionMap),
          multiple: true,
          // The renderer uses this for the "up to NMB" hint and pre-validation;
          // value is in bytes despite the `Mb` suffix (see FieldKPIFileUpload*).
          // Match the yup is-valid-size limit above.
          maxFileSizeMb: 500 * 1024 * 1024,
        },
      }),
  };
}

export function generalLedgerFormSchema(showNewFileField: boolean) {
  return yup.object(generalLedgerFields(showNewFileField));
}

export type GeneralLedgerPayload = yup.InferType<ReturnType<typeof generalLedgerFormSchema>>;

export function createGeneralLedgerUploadPayload(overrides: Partial<GeneralLedgerPayload> = {}) {
  return merge({}, generalLedgerFormSchema(false).getDefault(), overrides);
}
